export default __webpack_public_path__ + "static/media/avatar-lab.84749e22.svg";